import { types as coreTypes } from '@sitebuilder/core';

export const defaultColors: coreTypes.Colors = {
    '--color-white': {
        rgb: 'rgb(255, 255, 255)',
        cmyk: 'cmyk(0%, 0%, 0%, 0%)',
        spot: '',
    },
    '--color-black': {
        rgb: 'rgb(0, 0, 0)',
        cmyk: 'cmyk(0%, 0%, 0%, 100%)',
        spot: '',
    },
    '--color-grey': {
        rgb: 'rgb(204, 204, 204)',
        cmyk: 'cmyk(0%, 0%, 0%, 20%)',
        spot: '',
    },
    '--color-light-grey': {
        rgb: 'rgb(237, 237, 237)',
        cmyk: 'cmyk(0%, 0%, 0%, 7%)',
        spot: '',
    },
    '--color-green': {
        rgb: 'rgb(0, 166, 81)',
        cmyk: 'cmyk(100%, 0%, 100%, 0%)',
        spot: '',
    },
    '--color-red': {
        rgb: 'rgb(255, 0, 0)',
        cmyk: 'cmyk(100%, 0%, 0%, 100%)',
        spot: '',
    },
    '--color-purple': {
        hex: '#757ce8',
        rgb: 'rgb(117, 124, 232)',
        cmyk: 'cmyk(45%, 42%, 0%, 9%)',
        spot: '',
    },
    '--color-blue': {
        hex: '#03a9f4',
        rgb: 'rgb(3, 169, 244)',
        cmyk: 'cmyk(95%, 29%, 0%, 4%)',
        spot: '',
    },
    '--color-light-blue': {
        hex: '#7cb5ec',
        rgb: 'rgb(124,181,236)',
        cmyk: 'cmyk(47%, 23%, 0%, 7%)',
        spot: '',
    },
    '--color-none': {
        rgb: 'none',
        cmyk: '',
        spot: '',
    },

    // L1

    // canvas
    '--default-background-color': JSON.parse('"var(--color-white)"'),

    // text
    '--default-text-color': JSON.parse('"var(--color-black)"'),
    '--defualt-text-lighter': JSON.parse('"var(--color-light-grey)"'),
    '--primary-contrastText': JSON.parse('"var(--color-grey)"'),

    // primary
    '--color-primary': JSON.parse('"var(--color-black)"'),
    '--color-primary-lightest': JSON.parse('"var(--color-primary)"'),
    '--color-primary-lighter': JSON.parse('"var(--color-primary)"'),
    '--color-primary-medium': JSON.parse('"var(--color-primary)"'),
    '--color-primary-darker': JSON.parse('"var(--color-primary)"'),
    '--color-primary-darkest': JSON.parse('"var(--color-primary)"'),

    // primary
    '--color-secondary': JSON.parse('"var(--color-primary)"'),

    // border
    '--default-border-color': JSON.parse('"var(--color-primary)"'),

    // L2 - borders
    '--color-border-strong': JSON.parse('"var(--default-border-color)"'),
    '--color-border-weak': JSON.parse('"var(--default-border-color)"'),
    '--color-border-medium': JSON.parse('"var(--default-border-color)"'),

    // L2 - text
    '--color-text-primary': JSON.parse('"var(--default-text-color)"'),
    '--color-text-secondary': JSON.parse('"var(--default-text-color)"'),
    '--color-text-disabled': JSON.parse('"var(--default-text-color)"'),
    '--color-text-link': JSON.parse('"var(--default-text-color)"'),
    '--color-text-maxContrast': JSON.parse('"var(--color-white)"'),
    '--color-text-lighter': JSON.parse('"var(--defualt-text-lighter)"'),

    // primary
    '--color-primary-main': JSON.parse('"var(--color-primary)"'),
    '--color-primary-text': JSON.parse('"var(--color-primary)"'),
    '--color-primary-border': JSON.parse('"var(--color-primary)"'),
    '--color-primary-contrastText': JSON.parse('"var(--color-primary)"'),

    // secondary
    '--color-secondary-main': JSON.parse('"var(--color-secondary)"'),
    '--color-secondary-text': JSON.parse('"var(--color-secondary)"'),
    '--color-secondary-border': JSON.parse('"var(--color-secondary)"'),
    '--color-secondary-contrastText': JSON.parse('"var(--color-secondary)"'),

    // info (inherits from primary)
    '--color-info-main': JSON.parse('"var(--color-primary-main)"'),
    '--color-info-text': JSON.parse('"var(--color-primary-text)"'),
    '--color-info-border': JSON.parse('"var(--primary-contrastText)"'),

    // warning
    '--color-warning': JSON.parse('"var(--color-orange)"'),
    '--color-warning-main': JSON.parse('"var(--color-warning)"'),
    '--color-warning-text': JSON.parse('"var(--color-warning)"'),
    '--color-warning-border': JSON.parse('"var(--color-warning)"'),

    // success
    '--color-success': JSON.parse('"var(--color-green)"'),
    '--color-success-main': JSON.parse('"var(--color-success)"'),
    '--color-success-text': JSON.parse('"var(--color-success)"'),
    '--color-success-border': JSON.parse('"var(--color-success)"'),

    // error
    '--color-error': JSON.parse('"var(--color-red)"'),
    '--color-error-main': JSON.parse('"var(--color-error)"'),
    '--color-error-text': JSON.parse('"var(--color-error)"'),
    '--color-error-border': JSON.parse('"var(--color-error)"'),

    '--color-risk-indicator-tile-1': JSON.parse('"var(--color-primary-lightest)"'),
    '--color-risk-indicator-tile-2': JSON.parse('"var(--color-primary-lighter)"'),
    '--color-risk-indicator-tile-3': JSON.parse('"var(--color-primary-medium)"'),
    '--color-risk-indicator-tile-4': JSON.parse('"var(--color-primary-darker)"'),
    '--color-risk-indicator-tile-5': JSON.parse('"var(--color-primary-darkest)"'),

    '--color-growth-chart-line': JSON.parse('"var(--color-primary-border)"'),
    '--color-growth-chart-fill': JSON.parse('"var(--color-primary-lightest)"'),
    '--color-growth-chart-tooltip': JSON.parse('"var(--color-text-primary)"'),
    '--color-growth-chart-navigator': JSON.parse('"var(--color-primary-lightest)"'),
    '--color-growth-chart-navigator-fill': JSON.parse('"var(--color-primary-lightest)"'),
    '--color-growth-chart-range-button-stroke': JSON.parse('"var(--color-primary-lightest)"'),
    '--color-growth-chart-range-button-fill': JSON.parse('"var(--color-none)"'),
    '--color-growth-chart-range-button-hover': JSON.parse('"var(--color-text-primary)"'),
    '--color-growth-chart-range-button-selected': JSON.parse('"var(--color-text-lighter)"'),
    '--color-growth-chart-range-button-disabled': JSON.parse('"var(--color-text-primary)"'),
    '--color-equity-box': JSON.parse('"var(--color-primary-main)"'),
    '--color-stock-chart-tooltip': JSON.parse('"var(--color-text-primary)"'),
    '--color-stock-chart-range-button-stroke': JSON.parse('"var(--color-primary-border)"'),
    '--color-stock-chart-range-button-fill': JSON.parse('"var(--color-primary-main)"'),
    '--color-stock-chart-range-button-hover': JSON.parse('"var(--color-primary-main)"'),
    '--color-stock-chart-range-button-selected': JSON.parse('"var(--color-secondary-main)"'),
    '--color-stock-chart-range-button-disabled': JSON.parse('"var(--color-primary-text)"'),
    '--color-stock-chart-marker': JSON.parse('"var(--color-primary-main)"'),
    '--color-stock-chart-line': JSON.parse('"var(--color-primary-border)"'),
    '--color-stock-chart-fill-01': JSON.parse('"var(--color-primary-main)"'),
    '--color-stock-chart-fill-02': JSON.parse('"var(--color-secondary-main)"'),
    '--color-stock-chart-flag-fill': JSON.parse('"var(--color-primary-main)"'),
    '--color-stock-chart-flag-hover-fill': JSON.parse('"var(--color-secondary-main)"'),

    '--color-search-input-border': JSON.parse('"var(--color-grey)"'),
    '--color-dropdown-border': JSON.parse('"var(--color-grey)"'),
    '--color-placeholder': JSON.parse('"var(--color-grey)"'),
    '--color-border': JSON.parse('"var(--color-grey)"'),
};
